var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.manufacturer_count)?_c('a',{staticClass:"pBig col-md-7 text-center active-color fw-bold",attrs:{"href":`/manufacturers/?from=${_vm.from}`,"target":"_blank"}},[_vm._v("\n  "+_vm._s(_vm.$t('companyCount', { count: _vm.manufacturer_count }, _vm.manufacturer_count))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }